import React from "react";
import { format } from "date-fns";
import styled from "styles/styled_components";
import { Maybe } from "true-myth";

import { DateFormats, getLastYear } from "helpers/dates";
import { EMPTY_VAL } from "helpers/insights/sales_forecast";

const StyledLaborOverviewBox = styled.div`
  font-size: ${(props) => props.theme.text.size.base};
  padding: ${(props) => props.theme.spacing.small} 0
    ${(props) => props.theme.spacing.xsmall};
  text-align: center;
`;

const StyledLaborBoxHeader = styled.h6`
  color: ${(props) => props.theme.colors.dsGrayDark};
  letter-spacing: 2px;
  text-transform: uppercase;
`;

const StyledLaborBoxPercentage = styled.p`
  font-size: 48px;
  line-height: 50px;
  color: ${(props) => props.theme.colors.dsGrayDark};
`;

const StyledLaborBoxDescriptor = styled.p`
  color: ${(props) => props.theme.colors.dsGrayDark};
  font-weight: bold;
`;

interface ILaborOverviewBoxProps {
  totalCost: string;
  totalPercent: string;
  startDate: Maybe<Date>;
  endDate: Maybe<Date>;
}

function LaborOverviewBox({
  totalCost,
  totalPercent,
  startDate,
  endDate,
}: ILaborOverviewBoxProps) {
  const requiredDates = [startDate, endDate];
  const datesForDisplay = Maybe.all(...requiredDates).match({
    Just: ([start, end]) => {
      return (
        <p>{`${format(start, DateFormats.WEEKDAY_DATE)} - ${format(
          end,
          DateFormats.WEEKDAY_DATE
        )}`}</p>
      );
    },
    Nothing: () => null,
  });
  const lastYear = getLastYear();

  const isDisplayingPercent = totalPercent !== EMPTY_VAL;
  const displayValue = isDisplayingPercent ? totalPercent : totalCost;
  const descriptor = isDisplayingPercent && (
    <StyledLaborBoxDescriptor>
      of {lastYear} Gross Sales
    </StyledLaborBoxDescriptor>
  );

  return (
    <StyledLaborOverviewBox>
      <StyledLaborBoxHeader>Labor Cost</StyledLaborBoxHeader>
      {datesForDisplay}
      <StyledLaborBoxPercentage>{displayValue}</StyledLaborBoxPercentage>
      {descriptor}
    </StyledLaborOverviewBox>
  );
}

export default LaborOverviewBox;
